// extracted by mini-css-extract-plugin
export default {"cardMainSection":"Card_cardMainSection__nbXmO","cardContent":"Card_cardContent__X-ghI"};